import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppPasswordChangePage } from './app-password-change';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppPasswordChangePage,
  ],
  imports: [
    IonicPageModule.forChild(AppPasswordChangePage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppPasswordChangePageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-password-change/app-password-change.module.ts